import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="py-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-gray-600 border-t border-white/5">
      <p>{t("footer.copyright")}</p>
      <Link
        to="/privacy-policy"
        className="hover:text-gray-400 transition-colors"
      >
        {t("footer.privacy")}
      </Link>
    </footer>
  );
};

export default Footer;
